const component = {
  template: `
    <div class="generic">
      <div class="generic__section" ng-repeat="section in $ctrl.section">
        <div class="generic__image"><img ng-src="{{section.image}}" /></div>
        <div class="generic__content">
          <div class="generic__title" ng-bind-html="section.title"></div>
          <div class="generic__caption" ng-bind-html="section.caption"></div>
          <div class="generic__btnWrapper">
            <a class="generic__btn" href="{{section.btnUrl}}">{{section.btnTitle}}</a>
          </div>
        </div>
      </div>
    </div>
  `,
  bindings: {
    sections: '@'
  },
  controller() {
    this.$onInit = () => {
      this.section = JSON.parse(decodeURIComponent(this.sections));
    };
  }
};

export default component;



// WEBPACK FOOTER //
// ./js/containers/causePortal/components/genericSponsorPortal/index.js